import { PIECE_VALUES } from '@blind-kings/game-core';
import UnturnedSVG from '../icons/unturned.svg?react';
import PeasantSVG from '../icons/peasant.svg?react';
import AssassinSVG from '../icons/assassin.svg?react';
import KnightSVG from '../icons/knight.svg?react';
import CavalrySVG from '../icons/cavalry.svg?react';
import MageSVG from '../icons/mage.svg?react';
import HeroSVG from '../icons/hero.svg?react';
import KingSVG from '../icons/king.svg?react';
import type { SkinPack, SpriteDef } from './types';

const classicPieces: Partial<Record<number, SpriteDef>> = {
  [PIECE_VALUES.Empty]: { kind: 'svg', Svg: UnturnedSVG },
  [PIECE_VALUES.Unturned]: { kind: 'svg', Svg: UnturnedSVG },
  [PIECE_VALUES.Assassin]: { kind: 'svg', Svg: AssassinSVG },
  [PIECE_VALUES.Peasant]: { kind: 'svg', Svg: PeasantSVG },
  [PIECE_VALUES.Knight]: { kind: 'svg', Svg: KnightSVG },
  [PIECE_VALUES.Cavalry]: { kind: 'svg', Svg: CavalrySVG },
  [PIECE_VALUES.Mage]: { kind: 'svg', Svg: MageSVG },
  [PIECE_VALUES.Hero]: { kind: 'svg', Svg: HeroSVG },
  [PIECE_VALUES.King]: { kind: 'svg', Svg: KingSVG },
};

/**
 * Classic silhouette pack — Heroicons / Font Awesome marks tinted by army color.
 *
 * SVG pieces are single-frame; per-state motion comes from board transforms.
 * Sheet packs from the animation studio override individual pieces via
 * `registerSkinPack`.
 */
export const classicSkinPack: SkinPack = {
  id: 'classic',
  label: 'Classic',
  pieces: classicPieces,
  interactions: {
    move: {
      timings: {
        windup: 100,
        depart: 50,
        travel: 350,
        land: 150,
        cooldown: 50,
      },
    },
    attack: {
      timings: {
        windup: 150,
        depart: 50,
        travel: 400,
        clash: 250,
        resolve: 200,
        cooldown: 50,
      },
    },
    flip: {
      timings: {
        pulse: 100,
        reveal: 300,
        cooldown: 50,
      },
    },
  },
};
